import { NavLink, useNavigate } from 'react-router-dom';
import {useEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import {ExternalLink} from 'lucide-react';
import { ThemeToggle } from '../../components/ThemeToggle';
import { FolderModeButton } from './FolderModeButton';
import logo from './diskrepka-logo-ru.svg';
import '../../styles/diskrepka-header.css';
import '../../styles/diskrepka-open-menu.css';

export function DiskrepkaHeaderControls({ userId }: { userId: number }) {
  const navigate = useNavigate();
  const linkRef=useRef<HTMLAnchorElement>(null),menuRef=useRef<HTMLDivElement>(null);
  const [menu,setMenu]=useState<{x:number;y:number}|null>(null);
  useEffect(()=>{
    if(!menu)return;
    menuRef.current?.querySelector('button')?.focus();
    const outside=(event:PointerEvent)=>{if(!menuRef.current?.contains(event.target as Node)&&!linkRef.current?.contains(event.target as Node))setMenu(null);};
    const key=(event:KeyboardEvent)=>{if(event.key==='Escape'){event.preventDefault();setMenu(null);linkRef.current?.focus();}};
    const close=()=>setMenu(null);
    document.addEventListener('pointerdown',outside);document.addEventListener('keydown',key);window.addEventListener('resize',close);
    return()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('keydown',key);window.removeEventListener('resize',close);};
  },[menu]);
  return <>
    <NavLink ref={linkRef} className="diskrepka-header-link" to="/diskrepka" aria-label="Открыть Дискрепку" aria-haspopup="menu" aria-expanded={!!menu} title="Открыть Дискрепку. Правой кнопкой — открыть в отдельном окне" onContextMenu={event=>{
      event.preventDefault();event.stopPropagation();const rect=event.currentTarget.getBoundingClientRect();
      setMenu({x:Math.max(8,Math.min(event.clientX||rect.left,window.innerWidth-296)),y:Math.max(8,Math.min(event.clientY||rect.bottom,window.innerHeight-80))});
    }} onClick={event => {
      if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();setMenu(null); void navigate('/files');
      }
    }}><img src={logo} alt="" width="132" height="32"/></NavLink>
    <FolderModeButton userId={userId} compact/>
    <ThemeToggle/>
    {menu&&createPortal(<div ref={menuRef} className="diskrepka-open-menu" role="menu" aria-label="Дискрепка" style={{left:menu.x,top:menu.y}}>
      <button type="button" role="menuitem" onClick={()=>{window.open('/diskrepka','_blank','popup=yes,width=1280,height=820,noopener,noreferrer');setMenu(null);}}><ExternalLink size={18} aria-hidden="true"/><span>Открыть Дискрепку в отдельном окне</span></button>
    </div>,document.body)}
  </>;
}
